import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Stack } from '@mui/material';
import '../../../styles/DocumentDetails.css';
import TopBar from '../../../components/TopBar';
import useDocumentTitle from '../../../hooks/useDocumentTitle';
import DebitNoteForm from '../../debitNotes/components/DebitNoteForm';
import SBDebitNoteDetailsPageActionButton from '../components/SBDebitNoteDetailsPageActionButton';
import IrbmStatusCard from '../../common/IrbmStatusCard';
import { useGetDebitNoteHandler } from '../../debitNotes/dataHandlers/getCreditNoteHandler';
import DocumentSkeletonForm from '../../../components/DocumentSkeletonForm';

export default function SBDebitNoteDetailsPage() {
  useDocumentTitle('Self Billed Debit Note Details');
  const { document_id } = useParams();
  const { debitNote, isLoading } = useGetDebitNoteHandler(document_id);
  if (isLoading || !debitNote) {
    return <DocumentSkeletonForm />;
  }

  return (
    <Stack direction="column" sx={{ mt: '-1rem' }}>
      {debitNote && (
        <Box sx={{ pb: 4 }}>
          <TopBar title="Self Billed Debit Note Details" identifier={debitNote?.document_id}>
            <SBDebitNoteDetailsPageActionButton data={debitNote} />
          </TopBar>
        </Box>
      )}

      <IrbmStatusCard document={debitNote} />

      <DebitNoteForm onSubmit={() => {}} onCancel={() => {}} initialData={debitNote} readOnly={true} />
    </Stack>
  );
}
